import React from 'react';
import PhoneInputLib from 'react-phone-number-input';
import type { Country, Value } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { cn } from '../../utils';

export type { Country, Value } from 'react-phone-number-input';

export type PhoneInputProps = {
  id?: string;
  /** E.164 when fully entered (e.g. +84901234567); empty string when blank */
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  /** ISO 3166-1 alpha-2 — defaults to VN (+84) */
  defaultCountry?: Country;
  className?: string;
  'aria-invalid'?: boolean | 'true' | 'false';
};

/**
 * Shared phone input: flag + country code, stores E.164 value when valid.
 */
export function PhoneInput({
  id,
  value,
  onChange,
  disabled,
  placeholder = 'Phone number',
  defaultCountry = 'US',
  className,
  'aria-invalid': ariaInvalid,
}: PhoneInputProps) {
  return (
    <div className={cn('phone-input-field w-full min-w-0', className)}>
      <PhoneInputLib
        id={id}
        international
        defaultCountry={defaultCountry}
        countryCallingCodeEditable={false}
        placeholder={placeholder}
        value={value || undefined}
        onChange={(v: Value | undefined) => onChange(v ?? '')}
        disabled={disabled}
        className="PhoneInput"
        aria-invalid={ariaInvalid}
        autoComplete="tel"
      />
    </div>
  );
}
